import React from "react";

/**
 * TotalUsersCard
 * Shows the total number of active collaborators and the dominant age group.
 */
const TotalUsersCard = ({ total, ageData, icon }) => {
  const dominant = (ages) =>
    ages.reduce((a, b) => (b.val > a.val ? b : a)).label;
  const agesList = [
    { label: "18-25", val: ageData?.age_18_25 ?? 0 },
    { label: "26-35", val: ageData?.age_26_35 ?? 0 },
    { label: "36-45", val: ageData?.age_36_45 ?? 0 },
    { label: "46-55", val: ageData?.age_46_55 ?? 0 },
    { label: "55+",   val: ageData?.age_55_plus ?? 0 },
  ];
  const dominantAge = agesList.some((a) => a.val > 0)
    ? dominant(agesList)
    : "N/D";

  return (
    <div className="bg-white border border-slate-100/80 rounded-2xl p-4 flex flex-col justify-between h-full hover:shadow-sm transition-all duration-200">
      <div>
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-[#1D1F3F] text-white">
          {icon}
        </div>
        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mt-3.5 font-display">
          Total de Colaboradores
        </p>
        <div className="flex items-baseline gap-1 mt-1 font-display">
          <span className="text-5xl font-black text-[#1D1F3F] tracking-tight leading-none">
            {total}
          </span>
          <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
            activos
          </span>
        </div>
      </div>
      <div>
        <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wider mt-3 font-display">
          registrados en la empresa
        </p>
        <div className="mt-3.5 pt-3 border-t border-slate-200/60 flex justify-between items-center font-display">
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
            Edad
          </span>
          <span className="px-2 py-0.5 text-[14px] font-bold rounded-md bg-[#0075AC]/10 text-[#0075AC]">
            {dominantAge}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TotalUsersCard;
